import React, { Component } from 'react';
import { connect } from 'react-redux'; 
import { getDSDangChoAction,getDSHoanTatAction } from '../actions/authenticationActions';
import * as Lang from '../lang';
import HeaderPage from './headerPage';
import {
  isMobile
} from "react-device-detect";
import { checkCookie } from '../utils/cookies';

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css"; 
class DashboardPage extends Component {
  constructor(props) {
    super(props); 
    this.state = {
      startDate: new Date(),
      endDate: new Date(),
    }
  }
  updateState = state => { 
    this.setState({ selectedRows: state.selectedRows }); // triggers MyComponent to re-render with new state
  }

  handleStartDateChange = date => {
    this.setState({
      startDate: date
    });
  };

  handleEndDateChange = date => {
    this.setState({
      endDate: date
    });
  };

  handleLoadData = () => { 
    let tungay=this.state.startDate.getFullYear()+'-'+(this.state.startDate.getMonth()+1)+'-'+this.state.startDate.getDate();
    let denngay=this.state.endDate.getFullYear()+'-'+(this.state.endDate.getMonth()+1)+'-'+this.state.endDate.getDate();
    let token=localStorage.getItem('token');
    const data = {
      tungay, denngay, token
    }; 
    this.props.dispatch(getDSDangChoAction(data));
    this.props.dispatch(getDSHoanTatAction(data));
  };

  handleOpenCLS = (value)  => {
      window.location.replace("/cls/"+value);
  }

  componentDidMount() {
    document.title = Lang.LANG_TITLE;

    // remove và chuyển tiếp nếu url chuyển tiếp tồn tại
    if(localStorage.getItem('url') && checkCookie() !== null && localStorage.getItem('url')!==window.location.href){
      const url=localStorage.getItem('url');
      localStorage.removeItem('url'); 
      window.location.replace(url); 
    }
    let tungay=this.state.startDate.getFullYear()+'-'+(this.state.startDate.getMonth()+1)+'-'+this.state.startDate.getDate();
    let denngay=this.state.endDate.getFullYear()+'-'+(this.state.endDate.getMonth()+1)+'-'+this.state.endDate.getDate();
    let token=localStorage.getItem('token');
    const data = {
      tungay, denngay, token
    }; 
    this.props.dispatch(getDSDangChoAction(data));
    this.props.dispatch(getDSHoanTatAction(data));
  }
  
  render() {
    const bantay = { 
      cursor: "pointer", 
      width:"100%"
    };
    const legend={
      marginBottom: "0px",
      fontSize: "1.1rem",
      fontWeight: 700
    }
    
    let data_dangcho= [];
    let data_hoantat = [];

    
    //let isSuccess, message;
    if (this.props.response.dsdangcho.hasOwnProperty('response')) {
      if(typeof this.props.response.dsdangcho.response=="undefined"){ 
      }else{
        let data_rs_dc=this.props.response.dsdangcho.response.data;
        for(let i=0;i<data_rs_dc.length;i++){
          //data_dangcho.push({ id: data_rs_dc[i].id, mabenhnhan: data_rs_dc[i].MaBenhNhan, hoten: data_rs_dc[i].hotenbenhnhan,gioitinh:data_rs_dc[i].gioitinh,tuoi:data_rs_dc[i].tuoi,tenhangmuc:data_rs_dc[i].tenloaikham });
          data_dangcho.push(
          <tr style={bantay} key={data_rs_dc[i].id} onClick={() => isMobile?this.handleOpenCLS(data_rs_dc[i].id):""} onDoubleClick={() => isMobile?"":this.handleOpenCLS(data_rs_dc[i].id)}>
            <th scope={"row"}>{i+1}</th>
            <td>{data_rs_dc[i].MaBenhNhan}</td>
            <td>{data_rs_dc[i].hotenbenhnhan}</td>
            <td>{data_rs_dc[i].gioitinh}</td>
            <td>{data_rs_dc[i].tuoi}</td>
            <td>{data_rs_dc[i].tenloaikham}</td>
            <td>{data_rs_dc[i].ngaygiochidinh}</td> 
        </tr>) 
        }
      } 
    } 
    
    if (this.props.response.dshoantat.hasOwnProperty('response')) {
      if(typeof this.props.response.dshoantat.response=="undefined"){ 
      }else{
        let data_rs_ht=this.props.response.dshoantat.response.data;
        for(let i=0;i<data_rs_ht.length;i++){
          data_hoantat.push(
            <tr style={bantay} key={data_rs_ht[i].id} onClick={() => isMobile?this.handleOpenCLS(data_rs_ht[i].id):""} onDoubleClick={() => isMobile?"":this.handleOpenCLS(data_rs_ht[i].id)}>
              <th scope="row">{i+1}</th>
              <td>{data_rs_ht[i].MaBenhNhan}</td>
              <td>{data_rs_ht[i].hotenbenhnhan}</td>
              <td>{data_rs_ht[i].gioitinh}</td>
              <td>{data_rs_ht[i].tuoi}</td>
              <td title={"Ngày giờ CĐ: "+data_rs_ht[i].ngaygiochidinh}>{data_rs_ht[i].tenloaikham}</td> 
              <td>{data_rs_ht[i].tennguoihoantat}</td>
              <td>{data_rs_ht[i].ngaygiodocketqua}</td>
            </tr>
          )
          //data_hoantat.push({ id: data_rs_ht[i].id, mabenhnhan: data_rs_ht[i].MaBenhNhan, hoten: data_rs_ht[i].hotenbenhnhan,gioitinh:data_rs_ht[i].gioitinh,tuoi:data_rs_ht[i].tuoi,tenhangmuc:data_rs_ht[i].tenloaikham,nguoihoantat:data_rs_ht[i].nguoihoantat });
        }
      } 
    } 

    let class_fieldset="border p-2";
    let class_fieldset_parent="col-md-12";
    if(isMobile){
      class_fieldset="border p-2";
      class_fieldset_parent="col-md-12";
    }
    
    return (
      <div className="h-100 d-flex flex-column">
        <HeaderPage />
        <div className="container-fluid h-100">
          <div className="row">
              <div className="col-md-12 col-xs" style={{display:'inherit'}}>
                 <div className="col-md-12 border rounded" style={{display:'inherit',paddingTop:"2px",paddingBottom:"2px"}}>
    {isMobile?"Ngày":"Từ ngày"} <DatePicker
                    selected={this.state.startDate}
                    onChange={this.handleStartDateChange}
                    dateFormat="dd/MM/yy"
                  />{isMobile?"-":"đến ngày"} <DatePicker
                      selected={this.state.endDate}
                      onChange={this.handleEndDateChange}
                      dateFormat="dd/MM/yy"
                      style={{width:"10px"}}
                    />
                    <button type="button" className="btn btn-primary btn-sm" style={{marginLeft:'10px'}} onClick={this.handleLoadData}>Xem</button>
                  </div>
              </div> 
          </div>
          <div className="row" style={{height:"92%"}}>
            <div className={class_fieldset_parent}>
            <fieldset className={class_fieldset}>
              <legend style={legend}>Danh sách chờ đọc kết quả</legend>
              <table className="table table-bordered table-hover table-responsive" style={{maxHeight:"34vh"}}>
              <thead>
                <tr>
                  <th scope="col" style={{width:"3%"}}>#</th>
                  <th scope="col" style={{width:"5%"}}>ID</th>
                  <th scope="col" style={{width:"12%"}}>Họ tên</th>
                  <th scope="col" style={{width:"4%"}}>Giới</th>
                  <th scope="col" style={{width:"4%"}}>Tuổi</th>
                  <th scope="col" style={{width:"20%"}}>Hạng mục</th>
                  <th scope="col" style={{width:"5%"}}>Ngày CĐ</th> 
                </tr>
              </thead>
              <tbody>
               {data_dangcho}
              </tbody>
            </table>
            </fieldset> 
            </div>
            <div className={class_fieldset_parent}>
              <fieldset className={class_fieldset}>
                <legend style={legend}>Danh sách đã đọc kết quả</legend>
                <table className="table table-bordered table-hover table-responsive" style={{maxHeight:"34vh"}}>
              <thead>
                <tr>
                <th scope="col" style={{width:"3%"}}>#</th>
                  <th scope="col" style={{width:"5%"}}>ID</th>
                  <th scope="col" style={{width:"12%"}}>Họ tên</th>
                  <th scope="col" style={{width:"4%"}}>Giới</th>
                  <th scope="col" style={{width:"4%"}}>Tuổi</th>
                  <th scope="col" style={{width:"20%"}}>Hạng mục</th>
                  <th scope="col" style={{width:"7%"}}>Bác sĩ đọc</th>
                  <th scope="col" style={{width:"7%"}}>Ngày đọc</th> 
                </tr>
              </thead>
              <tbody>
                {data_hoantat}
              </tbody>
              </table>
              </fieldset>
            </div> 
        </div> 
        </div>
      </div>
    );
  }
}

const mapStateToProps = (response) => ({response});
export default connect(mapStateToProps)(DashboardPage); 
